import { AppService } from './app.service';
import { UsageService } from './usage.service';
import { AuthService } from './auth.service';
import { InstitutionService } from './institution.service';


export const SharedServices = [
  AppService,
  UsageService,
  AuthService,
  InstitutionService
]

export {
  AppService,
  UsageService,
  AuthService,
  InstitutionService,
}

